import { post } from "src/redux/slices/api/api";
import firebase from "firebase/compat/app";
import { SEND_ERROR_EMAIL_TO } from "src/config";

export async function createErrorLog(body: string ) {
  const db = firebase.firestore();
  for (const email of SEND_ERROR_EMAIL_TO) {
    const emailBody = {
      to: email,
      subject: 'Erro URBIA',
      body: body
    };
    const logBody = {
      ...emailBody,
      date: new Date()
    }
    await post('/mail/send', emailBody)
    await db.collection("logs").add(logBody);
  }
}